import Footer from "../component/Footer";
import Header from "../component/Header";
import { Link, useLocation, useParams } from "react-router-dom";
import ScrollToTop from "../component/ScrollToTop";

export default function BlogDetail4() {
  const id = useLocation();
  console.log(id.state.id, "id");
  return (
    <>
      <ScrollToTop>
        <Header />
        <div className="breadcumb-wrapper style2 bg-smoke">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="breadcumb-content justify-content-center">
                  <ul className="breadcumb-menu">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href="blog">Blog</a>
                    </li>
                    <li>What the Metaverse Can Offer Your Business</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* blog-details-area */}
        <section className="blog__details-area space">
          <div className="container">
            <div className="blog__inner-wrap">
              <div className="row justify-content-center">
                <div className="col-70">
                  <div className="blog__details-wrap">
                    <div className="blog__details-thumb">
                      <img src="./images/blog/blog_details01.jpg" alt="img" />
                    </div>
                    <div className="blog__details-content">
                      <div className="blog-post-meta">
                        <ul className="list-wrap">
                          <li>March 26, 2024</li>
                          <li>
                            <a href="blog.html">Branding</a>
                          </li>
                          <li>
                            <a href="blog.html">by Ashton Porter</a>
                          </li>
                        </ul>
                      </div>
                      <h2 className="title">
                        What the Metaverse Can Offer Your Business
                      </h2>
                      <p>
                        HopeFly Meta is exploring the new frontier of brand
                        interaction—through the Metaverse. We’re working with
                        forward-thinking companies to create virtual experiences
                        that go beyond flat screens and bring people into
                        immersive 3D environments.
                      </p>
                      <p>
                        This could be a virtual showroom, a branded event arena,
                        or an interactive training space. The goal? To build
                        deeper, more engaging relationships with your audience
                        using spatial computing and real-time interaction.
                      </p>
                      <blockquote>
                        <img
                          className="blockquote-icon"
                          src="./images/icon/quote.svg"
                          alt="img"
                        />
                        <p>
                          “The virtual product demo room HopeFly Meta built for
                          us had triple the engagement of our regular website
                          launch." — Head of Marketing, Tech Company
                        </p>
                      </blockquote>

                      <div className="blog__details-inner">
                        <div className="row align-items-center">
                          <div className="col-sm-6">
                            <div className="blog__details-inner-thumb">
                              <img
                                src="./images/blog/blog_details02.jpg"
                                alt="img"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="blog__details-inner-thumb">
                              <img
                                src="./images/blog/blog_details03.jpg"
                                alt="img"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <p>
                        As more tools like Apple Vision Pro and Meta Quest enter
                        the market, brands are investing in experiences that
                        feel personal—even when they’re entirely digital.
                      </p>
                      <p>
                        Whether it’s employee onboarding or a global event, the
                        Metaverse helps you show up in new ways—and we’re
                        excited to help brands shape their virtual future.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="wrapper">
          <div class="marquee marquee-wrap">
            <div class="marquee_group">
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="/service">
                    <i className="fas fa-star-of-life" />
                    Business Branding
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Web Development
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Cloud-based Application
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    AI Solution
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Metaverse Solution
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Marketing and SEO
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Web Service
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    E-commerce Plugin
                  </Link>
                </h6>
              </div>
            </div>
            <div aria-hidden="ture" class="marquee_group">
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="/service">
                    <i className="fas fa-star-of-life" />
                    Business Branding
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Web Development
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Cloud-based Application
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    AI Solution
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Metaverse Solution
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Marketing and SEO
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Web Service
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    E-commerce Plugin
                  </Link>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </ScrollToTop>
    </>
  );
}
